import {
  RANK_SYMBOL_TO_STR,
  REGION_LIST,
} from "@/game-lol/constants/constants.mjs";
import { /*HYPER_ROLL_RANKS,*/ TEMP_MODE } from "@/game-tft/constants.mjs";

const VALID_KEYS = ["key", "gql"];

export default function getFilters(
  urlSearchParams,
  page,
  isFutureSet = false,
  isRevivalSet = false,
  defaultMode = "RANKED",
  defaultRank = "PLATINUM+",
) {
  const modeParam = urlSearchParams?.get("mode");
  const mode = modeParam?.toUpperCase() ?? defaultMode;
  const isTempMode = mode === TEMP_MODE;
  // const daysParam = urlSearchParams?.get("days");
  // let days = daysParam?.match(/1[0-9]?[0-9]?|[2-9]/)?.[0] ?? 7; // 1 - 199 range or default to 7
  const regionParam = urlSearchParams?.get("region");
  const region = (
    REGION_LIST.find((i) => [i.key, i.name, i.gql].includes(regionParam))
      ?.name ?? REGION_LIST[0].name
  ).toUpperCase();
  const rankParam = urlSearchParams?.get("rank")?.trim();
  const rankSymbol = Object.getOwnPropertySymbols(RANK_SYMBOL_TO_STR).find(
    (SYMBOL) => {
      const item = RANK_SYMBOL_TO_STR[SYMBOL];
      if (VALID_KEYS.some((key) => !(key in item))) return false;
      if (VALID_KEYS.map((key) => item[key]).includes(rankParam)) return true;
      return false;
    },
  );
  const rank =
    (rankParam && RANK_SYMBOL_TO_STR[rankSymbol]?.gql) ?? defaultRank;
  // Duos and Trios
  const type = urlSearchParams?.get("type") ?? "ALL";
  const portal = urlSearchParams?.get("portal") ?? "ALL";
  const result = new URLSearchParams(); // In order: rank, region, mode, combo

  if (isFutureSet) {
    // PBE
    result.append("rank", "ALL");
    result.append("region", "WORLD");
    result.append("mode", "NORMAL");
    if (page === "comps" || page === "earlycomps")
      result.append("portal", portal);
  } else {
    if (mode !== "NORMAL") result.append("rank", rank);
    if (mode === "NORMAL") result.append("rank", "ALL");
    // result.append(
    //   "rank",
    //   rankParam?.toUpperCase() ??
    //     HYPER_ROLL_RANKS.PURPLE_PLUS.key.toUpperCase(),
    // );
    result.append("region", region);
    result.append("mode", mode);
    if (page === "comps" || page === "earlycomps") {
      result.append("portal", portal);
    }
  }

  if ((type === "DUOS" || type === "TRIOS") && page === "augments")
    result.append("combo", type.toLowerCase().replace(/s/, ""));

  if (isRevivalSet) {
    result.set("rank", "ALL");
    result.set("mode", "REVIVAL");
    if (page === "comps" || page === "earlycomps") {
      result.set("portal", "ALL");
    }
  }
  if (isTempMode) {
    result.set("rank", "ALL");
  }
  return result.toString().replace(/%2B/g, "+");
}
